import { z } from 'zod';

export const AuraResultStatus = z.enum([
  'HISTORIC',
  'CURRENT',
  'CALCULATED',
  'FAILED',
  'LOCKED',
]);

export type AuraResultStatusT = z.infer<typeof AuraResultStatus>;
